module.exports = __webpack_public_path__ + "static/media/tokyodecadence.cbe1085f.gif";